import { PieChartWidget } from './PieChartWidget';
import type { DashboardWidget } from '../../types/panelConfig';

interface Props {
  widget: Extract<DashboardWidget, { type: 'chart-donut' }>;
  sourceId: number | null | undefined;
}

export function DonutChartWidget({ widget, sourceId }: Props) {
  return <PieChartWidget widget={widget} sourceId={sourceId} variant="donut" />;
}
